export default __webpack_public_path__ + "static/media/030_corner1.av1.bb331dd6.mp4";